import { roles } from "@/constants";
import { AppstoreOutlined, EditOutlined, HistoryOutlined } from "@ant-design/icons";
import React from "react";
import { useSelector } from "react-redux";


const CustomTabs = ({ children, currentTab, onTabChange }) => {
  const { company, role } = useSelector(state => state.auth?.user);

console.log(role,"role")

  // Define tabs with associated labels and icons
  // const tabs = [
  //   { key: "1", icon: <AppstoreOutlined />, label: "Active Offers" },
  //   { key: "2", icon: <HistoryOutlined />, label: "Past Offers" },
  //   roles.onlyCompanyAdminAndSales.includes(role) && { key: "3", icon: <EditOutlined />, label: "Draft Offers" }
  // ];

  const tabs = [
    { key: "1", icon: <AppstoreOutlined />, label: "Active Offers" },
    { key: "2", icon: <HistoryOutlined />, label: "Past Offers" },
    // role access to restric it for tom sales
    ...(!roles.onlyCompanyAdminAndSales.includes(role) ? [{ key: "3", icon: <EditOutlined />, label: "Draft Offers" }] : [])
  ];
  
  return (
    <div>
      <div className="flex border-b border-gray-300 ">
        {tabs.map((tab, index) => (
          <div
            key={tab.key}
            onClick={() => onTabChange(tab.key)}
            className={`outline-none  cursor-pointer py-3 px-4 text-center text-sm flex items-center justify-center ${tab.key === currentTab
              ? "bg-white drop-shadow-lg shadow-md font-semibold text-themeBlue"
              : "bg-gray-100 "
              } ${index === tabs.length - 1 ? "" : ""}`}
          >
            <span className="flex items-center space-x-2">
              {tab.icon}
              <span>{tab.label}</span>
            </span>
          </div>
        ))}
      </div>
      <div className="mt-4 ">
        {React.Children.map(children, child =>
          child.props.tabKey === currentTab ? child : null
        )}
      </div>
    </div>
  );
};

export default CustomTabs;
